export const footerNavLinks = [
  {
    id: 1,
    title: "Полезные ссылки",
    links: [
      {
        id: 1,
        name: "Процесс поступления",
        link: "/",
      },
      {
        id: 2,
        name: "Болонский процесс",
        link: "/",
      },
      {
        id: 3,
        name: "Прибытие и встреча",
        link: "/",
      },
      {
        id: 4,
        name: "Зарубежные представители",
        link: "/",
      },
    ],
  },
  {
    id: 2,
    title: "Адрес МШМБ",
    links: [
      {
        id: 1,
        name: "Улица: 151 triq Эдгар Бернард",
      },
      {
        id: 2,
        name: "Город: Гзира",
      },
      {
        id: 3,
        name: "Гзира Страна: Мальта",
      },
      {
        id: 4,
        name: "Почтовый индекс: GZR 1707",
      },
    ],
  },
  {
    id: 3,
    title: "Контакты",
    links: [
      {
        id: 1,
        name: "Приемная комиссия:",
      },
      {
        id: 2,
        name: "+998 90 006 44 43 (Tel/WhatsApp)",
        link: "/",
      },
      {
        id: 3,
        name: "Отдел сотрудничества:",
      },
      {
        id: 4,
        name: "+998 95 794 44 42 (Tel/WhatsApp)",
        link: "/",
      },
    ],
  },
  {
    id: 4,
    title: "Социальные ссылки",
    links: [
      {
        id: 1,
        name: "Facebook",
        link: "/",
      },
      {
        id: 2,
        name: "Instagram",
        link: "/",
      },
      {
        id: 3,
        name: "Tiktok",
        link: "/",
      },
      {
        id: 4,
        name: "YouTube",
        link: "/",
      },
    ],
  },
];
